export const BUILD_VERSION = {
  "buildNumber": 127,
  "buildDate": "2026_07_07",
  "version": "00127/2026_07_07",
  "releaseVersion": "v1.0.20"
};